<template>
  <div
    v-if="gunInfo !== null && gunDataset.length > 0"
    class="modal-dialog modal-dialog-centered modal-xl"
    role="document"
  >
    <div
      class="modal-content"
      style="text-align: left !important"
    >
      <div class="modal-body p-0">
        <div class="card card-plain">
          <div class="card-body justify-content-left">
            <button
              ref="dismissButton"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              style="
                color: black;
                position: absolute;
                top: 0;
                right: 0;
                z-index: 99999 !important;
                margin: 10px;
                padding: 5px;
              "
            >
              <font-awesome-icon :icon="['fas', 'xmark']" />
            </button>
            <h3 class="text-start">Detailed View of Gun {{ gunInfo.gun_name }}</h3>
            <SteelCaseGunsEqualizationChart
              :datasets="gunDataset"
              :recipes="gunRecipes.map(recipe => ({
                ...recipe,
                target_throughput: gunInfo.is_gun_on_bottom_reciprocator ? null : recipe.target_throughput,
                target_throughput_bottom: gunInfo.is_gun_on_bottom_reciprocator ? recipe.target_throughput_bottom : null,
              }))"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    class="modal-dialog modal-dialog-centered modal-sm"
    role="document"
  >
    <div
      class="modal-content"
      style="text-align: left !important"
    >
      <div class="modal-body p-0">
        <div class="card card-plain">
          <div class="card-body justify-content-left">
            <button
              ref="dismissButton"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label=""
              style="
                color: black;
                position: absolute;
                top: 0;
                right: 0;
                z-index: 99999 !important;
                margin: 10px;
                padding: 5px;
              "
            >
              <font-awesome-icon :icon="['fas', 'xmark']" />
            </button>
            <div
              class="swal2-icon swal2-error swal2-icon-show"
              style="display: flex"
            >
              <span class="swal2-x-mark">
                <span class="swal2-x-mark-line-left"></span>
                <span class="swal2-x-mark-line-right"></span>
              </span>
            </div>
            <h3 class="text-center">Error</h3>
            <p class="text-center">Failed to fetch detailed data for this gun.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import SteelCaseGunsEqualizationChart from "./SteelCaseGunsEqualizationChart.vue";

library.add(faXmark);

export default {
  name: "GunDetailModal",
  components: {
    SteelCaseGunsEqualizationChart,
    FontAwesomeIcon,
  },
  props: {
    gunInfo: {
      type: Object,
      default: () => null,
    },
    gunDataset: {
      type: Array,
      default: () => [],
    },
    gunRecipes: {
      type: Array,
      default: () => [],
    },
  },
  emits: [],
  computed: {},
  methods: {
    closeModal() {
      const dismissButton = this.$refs.dismissButton;
      if (dismissButton) {
        dismissButton.click();
      }
    },
  },
};
</script>
